/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CommunityItemMinimal } from '../../models/community-item-minimal';
import { DtoCommunityUpdate } from '../../models/dto-community-update';

export interface CommunityControllerUpdate$Params {
  id: number;
      body: DtoCommunityUpdate
}

export function communityControllerUpdate(http: HttpClient, rootUrl: string, params: CommunityControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CommunityItemMinimal;
}>> {
  const rb = new RequestBuilder(rootUrl, communityControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CommunityItemMinimal;
      }>;
    })
  );
}

communityControllerUpdate.PATH = '/community/{id}';
